import PptxGenJS from 'pptxgenjs';

const LOGO_POSITION_X = 0;
const LOGO_POSITION_Y = 0;

export function addLogoSlide(pptx: PptxGenJS, slideDimensions: { width: number, height: number }, logoPath: string): void {
    const slide = createSlide(pptx);
    addLogoToSlide(slide, logoPath, slideDimensions);
}

function createSlide(pptx: PptxGenJS): any {
    return pptx.addSlide();
}

function addLogoToSlide(slide: any, logoPath: string, slideDimensions: { width: number, height: number }): void {
    slide.addImage({
        path: logoPath,
        x: LOGO_POSITION_X,
        y: LOGO_POSITION_Y,
        w: slideDimensions.width,
        h: slideDimensions.height
    });
}
